import React from "react";
import { Link, navigate } from "gatsby";
import kebabCase from "lodash.kebabcase";
import { Typography, TypographyVariants } from "@trussle/external-components";
import { trackEvent } from "../../helpers/analytics";
import { IGridColumnCard } from "../../types/IGridColumnCard";
import { GridColumnCard } from "../GridColumnCard";
import "./styles.scss";

export interface IProps {
  classNames?: string;
  title: string;
  url: string;
  headingType?: string;
  description: string;
  gridText: IGridColumnCard[];
  handleClick?: (e: any) => void;
  betterV2?: boolean;
}

export const GridColumn: React.FC<IProps> = (props) => {
  const {
    classNames,
    title,
    url,
    headingType,
    description,
    gridText,
    handleClick,
    betterV2,
  } = props;

  return (
    <nav className="gridColumn" id={`${kebabCase(title.toLowerCase())}`}>
      <div className={`gridColumn__contentContainer ${classNames}`}>
        {!betterV2 ? (
          <Link
            className="gridColumn__link"
            to={url}
            onClick={(e) => handleClick && handleClick(e)}
          >
            <Typography
              variant={headingType as TypographyVariants || "h6"}
              classes="gridColumn__title"
              gutterBottom
            >
              {title}
            </Typography>
            <Typography
              variant="h6"
              component="div"
              classes="gridColumn__description"
            >
              {description}
            </Typography>
          </Link>
        ) : (
          <Typography
            variant="h5"
            classes="gridColumn__title"
            gutterBottom
          >
            {title}
          </Typography>
        )}

      </div>
      <div className="gridColumn__linkContainer">
        {gridText.map((card) => (
          <GridColumnCard
            key={card.cardText}
            classNames={classNames}
            url={card.url}
            cardText={card.cardText}
            betterV2={betterV2}
            handleClick={(e) => {
              e.preventDefault();
              trackEvent(`Buyer profile - button - ${card.cardText}`);
              navigate(card.url);
            }}
          />
        ))}
      </div>
    </nav>
  );
};
